import { z } from 'zod';

// ============================================
// 探索房间类型共享常量
// ============================================

export const EXPLORATION_ROOM_BLUEPRINT_SLOT_VALUES = [
  'entrance',
  'monster',
  'elite',
  'event',
  'rest',
  'treasure',
  'boss',
  'special',
] as const;

export const EXPLORATION_ROOM_TYPE_VALUES = EXPLORATION_ROOM_BLUEPRINT_SLOT_VALUES;
export const ExplorationRoomTypeSchema = z.enum(EXPLORATION_ROOM_TYPE_VALUES);
export type ExplorationRoomTypeSchemaValue = z.infer<typeof ExplorationRoomTypeSchema>;

function normalizeBlueprintSlotValue(value: unknown): unknown {
  if (typeof value !== 'string') return value;

  const normalized = value.trim().toLowerCase();
  if (!normalized) return value;

  const exactMatch = EXPLORATION_ROOM_BLUEPRINT_SLOT_VALUES.find(slot => slot === normalized);
  if (exactMatch) return exactMatch;

  const prefixMatch = EXPLORATION_ROOM_BLUEPRINT_SLOT_VALUES.find(
    slot =>
      normalized.startsWith(`${slot} `) || normalized.startsWith(`${slot},`) || normalized.startsWith(`${slot}(`),
  );
  if (prefixMatch) return prefixMatch;

  const containsMatch = EXPLORATION_ROOM_BLUEPRINT_SLOT_VALUES.find(
    slot =>
      normalized.includes(` ${slot} `) ||
      normalized.includes(`, ${slot}`) ||
      normalized.includes(`${slot}-`) ||
      normalized.includes(`${slot}_`),
  );
  if (containsMatch) return containsMatch;

  const looseMatch = EXPLORATION_ROOM_BLUEPRINT_SLOT_VALUES.find(slot =>
    normalized.startsWith(`${slot} `) ||
    normalized.startsWith(`${slot},`) ||
    normalized.startsWith(`${slot}(`) ||
    normalized.includes(` ${slot} `) ||
    normalized.includes(`, ${slot}`) ||
    normalized.includes(`${slot}-`) ||
    normalized.includes(`${slot}_`),
  );
  return looseMatch || value;
}

export const WorldSiteRoomBlueprintSlotSchema = z.preprocess(normalizeBlueprintSlotValue, ExplorationRoomTypeSchema);
export type WorldSiteRoomBlueprintSlotValue = z.infer<typeof WorldSiteRoomBlueprintSlotSchema>;

export const ExplorationRoomType = ExplorationRoomTypeSchema;
export type ExplorationRoomTypeValue = z.infer<typeof ExplorationRoomType>;

export const EXPLORATION_ROOM_DISPLAY_TYPE_VALUES = [...EXPLORATION_ROOM_TYPE_VALUES, 'mystery'] as const;
export const ExplorationRoomDisplayTypeSchema = z.enum(EXPLORATION_ROOM_DISPLAY_TYPE_VALUES);
export type ExplorationRoomDisplayTypeSchemaValue = z.infer<typeof ExplorationRoomDisplayTypeSchema>;

export const ExplorationRoomDisplayType = ExplorationRoomDisplayTypeSchema;
export type ExplorationRoomDisplayTypeValue = z.infer<typeof ExplorationRoomDisplayType>;
